/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import styles from "./Card.module.css";
import {
  DirectionsCar,
  PhoneIphone,
  KeyboardArrowRightRounded,
} from "@material-ui/icons";
import cx from "classnames";
import { constant } from "./../../../shared/constants/constants";

const Card = (props) => {
  // user name which need to show in card
  let userName = props.info.userName
    ? `(${props.info.userName})`
    : "";

  // vehicle name which need to show in card
  let vehicleName = props.info.vehicleName;

  // status(offline/online/unknown) color
  let updatedStatusColor = "green";
  if (props.info.status === constant.OFFLINE) {
    updatedStatusColor = "gray";
  }
  if (props.updatedStatus === constant.UNKNOWN) {
    updatedStatusColor = "red";
  }

  return (
    <div
      className={cx(styles.Card, props.selected ? styles.Selected : null)}
      onClick={() => props.vehicleSelect(props.info.key, props.info.id)}>
      <div className={styles.CarIconCont}>
        {props.info.type === "user" ? (
          <PhoneIphone color="inherit" fontSize="inherit" />
        ) : (
          <DirectionsCar color="inherit" fontSize="inherit" />
        )}
      </div>
      <div className={styles.InfoCont}>
        <h4 className={styles.VehicleInfo}>
          {vehicleName}
          {/* {userName && <span>&nbsp;&nbsp;{userName}</span>} */}
        </h4>
        <hr />
        <div className={styles.Stats}>
          {/* <div className={styles.IB1}>
            <p className={styles.StatUp}>
              {constant.STATUS}
              <span
                className={styles.Dot}
                style={{ backgroundColor: props.info.color }}
              />
            </p>
            <p style={{ fontSize: "14px", color: props.info.color }}>
              {props.info.status}
            </p>
          </div> */}
          {/* <div className={styles.Vr} /> */}
          <div className={styles.IB2}>
            <p className={styles.StatUp}>{constant.LAST_UPDATED}</p>
            <p
              style={{
                fontSize: "14px",
                color: updatedStatusColor,
              }}>
              {props.updatedStatus}
            </p>
          </div>
        </div>
      </div>
      <div
        title={constant.CHECK_DETAILS}
        style={{ color: "#8fa225", cursor: "pointer" }}
        onClick={() =>
          props.showVehicleDetails(
            props.info.key,
            props.info.id,
            props.info.userName,
            props.info.vehicleName,
            props.info.status,
            props.updatedStatus,
            props.info.vehicleId,
            props.info.userId
          )
        }>
        <KeyboardArrowRightRounded color="inherit" />
      </div>
    </div>
  );
};

export default Card;
